import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import notify from '../../../../shared/feedback/notifications';
import * as Features from './../../../../shared/Features';
import { IImageThumbnail } from './Entities';
import { Translate } from './../../../../shared/LanguageService';
import * as actions from './actions/ImageProcessingActions';
import { isBrokerAgent } from '../../utils/brokerAgentUtils';
import CopyLinkModal from './CopyLinkModal';
import { Resolution } from './Entities';
import ZipLinkButtonMenu from './ZipLinkButtonMenu';

interface IProps {
    actions: any;
    allowChangeCategories: boolean;
    allowStitching: boolean;
    canDelete: () => boolean;
    canDeletePhotos: boolean;
    categories: number[];
    displayStitchRadio: boolean;
    imageThumbnails: IImageThumbnail[];
    leftStitchImage?: any;
    orderId: number;
    rightStitchImage?: any;
    selectAllImages: (thumbnails: IImageThumbnail[]) => void;
    selectedCategory: number;
    selectedImages: number[];
    selectingMultiple: boolean;
    selectMultipleActionLoading: boolean;
    setSelectMultipleActionLoading: (selectMultipleActionLoading: boolean) => void;
    setShowCompareImages: (showCompareImages: boolean) => void;
    setShowCreateStitchedImageModal: (showCreateStitchedImageModal: boolean) => void;
    shouldShowAddedPhotos: boolean;
    showCreateStitchedImageModal: boolean;
    toggleRadio: () => void;
    toggleReturnImageCommentSection: () => void;
    toggleSelectingMultiple: () => void;
    downloadFile: (url: string, data?: any) => Promise<any>;
    user: any;
}

interface IState {
    selectedCategory: {
        value: number;
        label: string;
    };
    changingCategories: boolean;
    anchorEl: HTMLElement | null;
    isLinkModalOpen: boolean;
    downloadLink?: string;
}

class SelectMultipleToolbox extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedCategory: {
                value: 1,
                label: Translate('photo-category/normal')
            },
            changingCategories: false,
            anchorEl: null,
            isLinkModalOpen: false,
            downloadLink: undefined
        };
    }

    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    downloadLink = (resolution: Resolution) => {
        this.setState({ isLinkModalOpen: true });

        actions
            .getZipDownloadLink(this.props.orderId, resolution)
            .then((result) => {
                this.setState({ downloadLink: result.downloadLink });
            })
            .catch((error) => {
                this.setState({ isLinkModalOpen: false });
                console.error(error);
            });
    };

    onDeleteMultipleSave = () => {
        this.props.setSelectMultipleActionLoading(true);
        this.props.actions
            .deleteMultiple(this.props.orderId, this.props.selectedImages)
            .then(() => {
                this.props.setSelectMultipleActionLoading(false);
                notify.success(Translate('image-processing/button-label/delete-multiple/success'));
            })
            .catch(() => {
                this.props.setSelectMultipleActionLoading(false);
                notify.failure(Translate('image-processing/button-label/delete-multiple/error'));
            });
    };

    toggleChangeCategory = () => {
        this.setState(
            (prevState) =>
                ({
                    changingCategories: !prevState.changingCategories
                } as IState)
        );
    };

    onImagesCategorySave = () => {
        this.props.setSelectMultipleActionLoading(true);
        this.props.actions
            .updateImagesCategory(
                this.props.orderId,
                this.props.selectedImages,
                this.state.selectedCategory
            )
            .then(() => {
                this.toggleChangeCategory();
                this.props.setSelectMultipleActionLoading(false);
                notify.success(Translate('image-processing/button-label/update-category/success'));
            })
            .catch(() => {
                this.props.setSelectMultipleActionLoading(false);

                notify.failure(Translate('image-processing/button-label/update-category/error'));
            });
    };

    showDownloadAndMarkAllButtons = (markedIsCustomerApproved: boolean): boolean => {
        let { user } = this.props;
        let isCustomer = isBrokerAgent(user.details.role);
        return (
            this.props.selectingMultiple &&
            !this.props.selectMultipleActionLoading &&
            (!isCustomer || (isCustomer && markedIsCustomerApproved))
        );
    };

    download = (images: number[]) => {
        this.props.setSelectMultipleActionLoading(true);
        notify.success(Translate('image-processing/button-label/download-images/started'));

        let { apiUrl } = window.appConfig;

        this.props
            .downloadFile(
                `${apiUrl}/views/orders/${this.props.orderId}/imageprocessing/download/group`,
                {
                    images: images
                }
            )
            .then((result: boolean) => {
                this.props.setSelectMultipleActionLoading(false);
            })
            .catch(() => {
                this.props.setSelectMultipleActionLoading(false);
                notify.failure(Translate('image-processing/button-label/download-images/error'));
            });
    };

    render() {
        let markedIsCustomerApproved: boolean = false;
        if (this.props.user.details.isCustomer) {
            let numMarkedPurchasedImages: number = 0;
            for (var i = 0; i < this.props.selectedImages.length; i++) {
                const imageId = this.props.selectedImages[i];
                const thumbnail = this.props.imageThumbnails.find(
                    (thumb: IImageThumbnail): boolean => {
                        return thumb.id === imageId;
                    }
                );
                if (thumbnail && thumbnail.isCustomerApproved) {
                    numMarkedPurchasedImages++;
                }
            }
            markedIsCustomerApproved =
                numMarkedPurchasedImages === this.props.selectedImages.length;
        }

        const { anchorEl } = this.state;

        return (
            <div className="order-row-toolbox">
                <CopyLinkModal
                    open={this.state.isLinkModalOpen}
                    onClose={() => this.setState({ isLinkModalOpen: false })}
                    link={this.state.downloadLink}
                />
                {this.props.shouldShowAddedPhotos && (
                    <div>
                        <ButtonToolbar className="stitch-buttons">
                            {this.props.allowStitching && !this.props.selectMultipleActionLoading &&
                                this.props.user &&
                                this.props.user.details &&
                                this.props.user.details.role !== 'role/photographer' && (
                                <ButtonGroup>
                                    <Button
                                        bsStyle={this.props.displayStitchRadio ? 'primary' : 'info'}
                                        className="stitch-button"
                                        onClick={this.props.toggleRadio}
                                        disabled={
                                            !this.props.imageThumbnails.some(
                                                (img) =>
                                                    img.highResolutionHeight >
                                                    img.highResolutionWidth
                                            )
                                        }
                                    >
                                        <i className="material-icons md-18">looks_one</i>
                                        <i className="material-icons md-18">add</i>
                                        <i className="material-icons md-18">looks_two</i>
                                    </Button>
                                </ButtonGroup>
                            )}
                            {this.props.allowStitching &&
                                this.props.leftStitchImage &&
                                this.props.rightStitchImage &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        <Button
                                            bsStyle="primary"
                                            onClick={() =>
                                                this.props.setShowCreateStitchedImageModal(true)
                                            }
                                        >
                                            {Translate(
                                                'image-processing/button-label/stitch-images'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                )}
                            {!this.props.selectingMultiple &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        <OverlayTrigger
                                            delay={300}
                                            placement="top"
                                            overlay={
                                                <Tooltip id="image-processing-list-stitch-tooltip">
                                                    {Translate(
                                                        'image-processing/button-tooltip/select-many/info'
                                                    )}
                                                </Tooltip>
                                            }
                                        >
                                            <Button
                                                bsStyle="info"
                                                className="stitch-button"
                                                onClick={this.props.toggleSelectingMultiple}
                                            >
                                                <i className="material-icons">check_box</i>{' '}
                                                {Translate(
                                                    'image-processing/button-label/select-many/enable'
                                                )}
                                            </Button>
                                        </OverlayTrigger>
                                    </ButtonGroup>
                                )}
                            {this.props.selectingMultiple &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        <Button
                                            bsStyle="secondary"
                                            className="stitch-button"
                                            onClick={this.props.toggleSelectingMultiple}
                                        >
                                            <i className="material-icons">cancel</i>{' '}
                                            {Translate(
                                                'image-processing/button-label/select-many/disable'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                )}

                            {Features.hasFeature(
                                Features.ApproveImagesBySE360,
                                this.props.user
                            ) && (
                                <ZipLinkButtonMenu
                                    onDownload={this.downloadLink}
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onOpen={this.handleClick}
                                    onClose={this.handleClose}
                                />
                            )}

                            {this.showDownloadAndMarkAllButtons(markedIsCustomerApproved) && (
                                <ButtonGroup>
                                    <Button
                                        className="select-many-btn"
                                        bsStyle="info"
                                        onClick={() =>
                                            this.props.selectAllImages(this.props.imageThumbnails)
                                        }
                                    >
                                        {this.props.selectedImages.length ===
                                        this.props.imageThumbnails.length
                                            ? Translate(
                                                  'image-processing/button-label/select-many/deselect-all'
                                              )
                                            : Translate(
                                                  'image-processing/button-label/select-many/select-all'
                                              )}
                                    </Button>
                                </ButtonGroup>
                            )}
                            {this.props.selectingMultiple &&
                                this.props.canDelete() &&
                                this.props.canDeletePhotos &&
                                !markedIsCustomerApproved &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        {this.props.selectedImages.length === 0 && (
                                            <OverlayTrigger
                                                delay={300}
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="image-processing-list-delete-tooltip">
                                                        {Translate(
                                                            'image-processing/button-tooltip/delete-multiple/must-select'
                                                        )}
                                                    </Tooltip>
                                                }
                                            >
                                                <div
                                                    style={{
                                                        cursor: 'not-allowed',
                                                        display: 'inline-block'
                                                    }}
                                                >
                                                    <Button
                                                        bsStyle="danger"
                                                        className="stitch-button"
                                                        style={{
                                                            pointerEvents: 'none'
                                                        }}
                                                        onClick={this.onDeleteMultipleSave}
                                                        disabled={
                                                            this.props.selectedImages.length === 0
                                                        }
                                                    >
                                                        <i className="material-icons">delete</i>{' '}
                                                        {Translate(
                                                            'image-processing/button-label/delete-multiple/edit'
                                                        )}
                                                    </Button>
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                        {this.props.selectedImages.length > 0 && (
                                            <Button
                                                bsStyle="danger"
                                                className="stitch-button"
                                                onClick={this.onDeleteMultipleSave}
                                                disabled={this.props.selectedImages.length === 0}
                                            >
                                                <i className="material-icons">delete</i>{' '}
                                                {Translate(
                                                    'image-processing/button-label/delete-multiple/edit'
                                                )}
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                )}
                            {this.props.selectingMultiple &&
                                !this.props.selectMultipleActionLoading &&
                                Features.hasFeature(
                                    Features.ReturnEditedImage,
                                    this.props.user
                                ) && (
                                    <ButtonGroup>
                                        {this.props.selectedImages.length === 0 && (
                                            <OverlayTrigger
                                                delay={300}
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="image-processing-list-return-tooltip">
                                                        {Translate(
                                                            'image-processing/button-tooltip/multiple-returns/must-select'
                                                        )}
                                                    </Tooltip>
                                                }
                                            >
                                                <div
                                                    style={{
                                                        cursor: 'not-allowed',
                                                        display: 'inline-block'
                                                    }}
                                                >
                                                    <Button
                                                        bsStyle="warning"
                                                        className="stitch-button"
                                                        style={{
                                                            pointerEvents: 'none'
                                                        }}
                                                        onClick={
                                                            this.props
                                                                .toggleReturnImageCommentSection
                                                        }
                                                        disabled={
                                                            this.props.selectedImages.length === 0
                                                        }
                                                    >
                                                        <i className="material-icons">undo</i>{' '}
                                                        {Translate(
                                                            'image-processing/button-label/multiple-returns/return'
                                                        )}
                                                    </Button>
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                        {this.props.selectedImages.length > 0 && (
                                            <Button
                                                bsStyle="warning"
                                                className="stitch-button"
                                                disabled={this.props.selectedImages.length === 0}
                                                onClick={this.props.toggleReturnImageCommentSection}
                                            >
                                                <i className="material-icons">undo</i>
                                                {Translate(
                                                    'image-processing/button-label/multiple-returns/return'
                                                )}
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                )}
                            {this.props.selectingMultiple &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        {this.props.selectedImages.length < 2 && (
                                            <OverlayTrigger
                                                trigger={['hover', 'focus']}
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="image-processing-list-compare-tooltip">
                                                        {Translate(
                                                            'order/image-processing/button-toolbar/tooltip/compare-disabled'
                                                        )}
                                                    </Tooltip>
                                                }
                                            >
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        cursor: 'not-allowed'
                                                    }}
                                                >
                                                    <Button
                                                        bsStyle="info"
                                                        style={{
                                                            pointerEvents: 'none'
                                                        }}
                                                        className="stitch-button"
                                                        disabled={
                                                            this.props.selectedImages.length < 2
                                                        }
                                                        onClick={() =>
                                                            this.props.setShowCompareImages(true)
                                                        }
                                                    >
                                                        <i className="material-icons">compare</i>{' '}
                                                        {Translate(
                                                            'order/image-processing/button-toolbar/button/compare'
                                                        )}
                                                    </Button>
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                        {this.props.selectedImages.length > 1 && (
                                            <Button
                                                bsStyle="info"
                                                className="stitch-button"
                                                disabled={this.props.selectedImages.length < 2}
                                                onClick={() =>
                                                    this.props.setShowCompareImages(true)
                                                }
                                            >
                                                <i className="material-icons">compare</i>{' '}
                                                {Translate(
                                                    'order/image-processing/button-toolbar/button/compare'
                                                )}
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                )}

                            {this.props.allowChangeCategories &&
                                this.props.selectingMultiple &&
                                !markedIsCustomerApproved &&
                                !this.props.selectMultipleActionLoading &&
                                !this.state.changingCategories && (
                                    <ButtonGroup>
                                        {this.props.selectedImages.length === 0 && (
                                            <OverlayTrigger
                                                delay={300}
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="image-processing-list-update-category-tooltip">
                                                        {Translate(
                                                            'image-processing/button-tooltip/update-category/must-select'
                                                        )}
                                                    </Tooltip>
                                                }
                                            >
                                                <div
                                                    style={{
                                                        cursor: 'not-allowed',
                                                        display: 'inline-block'
                                                    }}
                                                >
                                                    <Button
                                                        bsStyle="info"
                                                        style={{
                                                            pointerEvents: 'none'
                                                        }}
                                                        className="stitch-button"
                                                        disabled={
                                                            this.props.selectedImages.length === 0
                                                        }
                                                        onClick={this.toggleChangeCategory}
                                                    >
                                                        <i className="material-icons">edit</i>{' '}
                                                        {Translate(
                                                            'image-processing/button-label/update-category/edit'
                                                        )}
                                                    </Button>
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                        {this.props.selectedImages.length > 0 && (
                                            <Button
                                                bsStyle="info"
                                                className="stitch-button"
                                                disabled={this.props.selectedImages.length === 0}
                                                onClick={this.toggleChangeCategory}
                                            >
                                                <i className="material-icons">edit</i>{' '}
                                                {Translate(
                                                    'image-processing/button-label/update-category/edit'
                                                )}
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                )}
                            {this.props.allowChangeCategories &&
                                this.props.selectingMultiple &&
                                this.state.changingCategories &&
                                !markedIsCustomerApproved &&
                                !this.props.selectMultipleActionLoading && (
                                    <ButtonGroup>
                                        <Button
                                            bsStyle="secondary"
                                            className="stitch-button"
                                            onClick={this.toggleChangeCategory}
                                        >
                                            {Translate(
                                                'image-processing/button-label/update-category/cancel'
                                            )}
                                        </Button>
                                        <Button
                                            bsStyle="success"
                                            className="stitch-button"
                                            disabled={this.props.selectedImages.length === 0}
                                            onClick={this.onImagesCategorySave}
                                        >
                                            <i className="material-icons">save</i>{' '}
                                            {Translate(
                                                'image-processing/button-label/update-category/save'
                                            )}
                                        </Button>
                                        <Select
                                            className="Select"
                                            multi={false}
                                            clearable={false}
                                            isSearchable={false}
                                            value={this.state.selectedCategory}
                                            options={this.props.categories.map((x: any) => {
                                                return {
                                                    value: x.id,
                                                    label: Translate(x.name)
                                                };
                                            })}
                                            onChange={(e: any) =>
                                                this.setState({
                                                    selectedCategory: {
                                                        value: e.value,
                                                        label: e.label
                                                    }
                                                } as IState)
                                            }
                                        />
                                    </ButtonGroup>
                                )}
                            {this.showDownloadAndMarkAllButtons(markedIsCustomerApproved) && (
                                <ButtonGroup>
                                    <Button
                                        bsStyle="info"
                                        className="download-button"
                                        disabled={this.props.selectedImages.length < 1}
                                        onClick={() => this.download(this.props.selectedImages)}
                                    >
                                        <i className="material-icons">file_download</i>{' '}
                                        {Translate(
                                            'order/image-processing/button-toolbar/button/download'
                                        )}
                                    </Button>
                                </ButtonGroup>
                            )}

                            {this.props.selectMultipleActionLoading && (
                                <i className="load-spin-dark" />
                            )}
                        </ButtonToolbar>
                    </div>
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            updateImagesCategory: (orderId: number, imageIds: number[], category: number) =>
                dispatch(actions.updateImagesCategory(orderId, imageIds, category)),
            deleteMultiple: (orderId: number, imageIds: number[]) =>
                dispatch(actions.deleteMultiple(orderId, imageIds))
        }
    };
}

function mapStateToProps(state: any) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectMultipleToolbox);
